import React from 'react';
import { connect } from 'react-redux';
import {
  setBearerToken,
} from '../../actions';
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { parse } from 'query-string';

interface IProps extends RouteComponentProps {
  setBearerToken(bearerToken: string|null): void;
}

class SetBearerTokenContainer extends React.PureComponent<IProps> {
  componentDidMount(): void {
    const { setBearerToken } = this.props;
    const search: any = parse(this.props.location.search);
    const bearerToken = search.token;
    setBearerToken(bearerToken);
  }

  render() {
    return <Redirect to='/' />
  }
}

export default withRouter(connect(null, {
  setBearerToken,
})(SetBearerTokenContainer));
